"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3772],{

/***/ 53772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57833);
/* harmony import */ var static_pages_foodProgram_Customers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43518);
/* harmony import */ var static_pages_foodProgram_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54397);
/* harmony import */ var system_components_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10758);










var COMPANY_AMOUNT = 200;
var Companies = function(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.useTheme)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("food_program").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "section"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
            py: {
                xs: 3,
                md: 6
            },
            textAlign: "center",
            bgcolor: theme.palette.grey[100],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: 880,
                    maxWidth: {
                        xs: 550,
                        md: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(static_pages_foodProgram_Utils__WEBPACK_IMPORTED_MODULE_4__/* .FoodProgramH2 */ .s, {
                        mb: {
                            xs: 3,
                            md: 4
                        },
                        children: t("companies.title", {
                            amount: COMPANY_AMOUNT
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: 880,
                    maxWidth: {
                        xs: 650,
                        md: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(static_pages_foodProgram_Customers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Companies);


/***/ })

}]);